
import { createSlice } from '@reduxjs/toolkit';
import { fetcherGet, fetcherPost, fetcherPut } from '../utils/fetcher';
import { setLoader } from './commonSlice';
import { APIS, isEmpty } from '../utils/constants';
// import en from "../../src/nls/en.json"

const initialState = {
    allMessages: [],
    userMessageDetails: [],
    upNextData: [],
    requestType: [],
    messageSelectedmentor: null,
    chatUsers: []
}

const massageSlice = createSlice({
    name: 'massage',
    initialState,
    reducers: {
        setMessages: (state, action) => {
            state.allMessages = action.payload;
        },
        setUserMessage: (state, action) => {
            state.userMessageDetails = action.payload;
        },
        setUpNextData: (state, action) => {
            state.upNextData = action.payload;
        },
        setRequestType: (state, action) => {
            state.requestType = action.payload;
        },
        setMessageSelectedmentor: (state, action) => {
            state.messageSelectedmentor = action.payload;
        },
        setChatUsers: (state, action) => {
            state.chatUsers = action.payload;
        }
    }
});

export function getAllUserMassage() {
    return (dispatch) => {
        fetcherGet(APIS?.GET_ALL_MASSAGES)
            .then((response) => {
                const massages = !isEmpty(response?.data) ? response?.data : [];
                dispatch(setMessages(massages));
                dispatch(setLoader(false));
            })
            .catch((err) => {
                console.error(err);
                dispatch(setLoader(false));
            });
    };
}

export function getUserMassage(userId) {
    const url = `${APIS?.GET_USER_MESSAGE}?receiver_id=${userId}`
    return (dispatch) => {

        fetcherGet(url)
            .then((response) => {
                const massages = !isEmpty(response?.data) ? response?.data : [];
                dispatch(setUserMessage(massages));
                dispatch(setLoader(false));
            })
            .catch((err) => {
                console.error(err);
                dispatch(setLoader(false));
            });
    };
}

export function getUpNextData(month, year) {

    let URL = APIS?.GET_DASHBOARD_UPNEXT_DATA;
    if (month) {
        URL = `${APIS?.GET_DASHBOARD_UPNEXT_DATA}?month=${month}&year=${year}`
    }

    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherGet(URL)
            .then((response) => {
                const data = !isEmpty(response?.data) ? response?.data : [];
                dispatch(setUpNextData(data));
                dispatch(setLoader(false));
            })
            .catch((err) => {
                console.error(err);
                dispatch(setLoader(false));
            });
    };
}

export function postSendMessage(payload, callBack) {
    return (dispatch) => {

        fetcherPost(APIS?.POST_SEND_MESSAGE, payload)
            .then(() => {
                if (callBack && typeof callBack === 'function') {
                    callBack();
                }
                dispatch(setLoader(false));
            })
            .catch((error) => {
                if (callBack && typeof callBack === 'function') {
                    callBack(error?.response?.data?.data?.message);
                }
                dispatch(setLoader(false));
            });
    };
}

export function postRetakeQuiz(payload, handleDialogOpen, msg) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPost(APIS?.POST_RETAKE_QUIZ, payload)
            .then(() => {
                dispatch(setLoader(false));
                handleDialogOpen(msg)
            })
            .catch((err) => {
                console.error(err);
                dispatch(setLoader(false));
            });
    };
}

export function getRequest() {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherGet(APIS?.GET_REQUEST_TYPE)
            .then((response) => {
                const data = !isEmpty(response?.data) ? response?.data : [];
                dispatch(setRequestType(data));
                dispatch(setLoader(false));
            })
            .catch((err) => {
                console.error(err);
                dispatch(setLoader(false));
            });
    };
}

export function markReadMessage(payload) {
    return (dispatch) => {
        // dispatch(setLoader(true));
        fetcherPut(APIS?.MARK_READ_MESSAGE, payload)
            .then(() => {
                dispatch(getAllUserMassage())
                // dispatch(setLoader(false));
            })
            .catch(() => {
                // dispatch(setLoader(false));
            });
    };
}

export function getChatUsers(param) {
    return (dispatch) => {
        let URL = APIS?.GET_CHAT_USERS
        if (param) {
            URL = `${APIS?.GET_CHAT_USERS + param}`
        }
        fetcherGet(URL)
            .then((res) => {

                dispatch(setChatUsers(res?.data ? res?.data : []));

                // if (res?.data?.Mentors) {
                //     dispatch(setChatUsers(res?.data?.Mentors));
                // } else if (res?.data?.Students) {
                //     dispatch(setChatUsers(res?.data?.Students));
                // } else if (res?.data?.Users) {
                //     dispatch(setChatUsers(res?.data?.Users));
                // } else {
                //     dispatch(setChatUsers(res?.data ? res?.data : []));
                // }
            })
            .catch((err) => {
                console.error(err);
            });
    };
}

export const { setIsLoaded, setMessages, setUserMessage, setUpNextData, setRequestType, setMessageSelectedmentor, setChatUsers } = massageSlice.actions;
export default massageSlice.reducer;